import React, { useEffect, useState } from "react"
import AccountSettings from "../../views/account/AccountSettings"
import { useDispatch, useSelector } from "react-redux"
import { useForm, FormProvider } from "react-hook-form"
import { getUserInfo } from "../../../reducers/userInfo"
import Helpers, { sleep } from "../../../utils/Helpers"
import { updateUserInfo } from "../../../actions/userActions"
import { Form } from "components/views/atoms/forms/Form"

export const AccountSettingsContext = React.createContext()

const formatDateOfBirth = (dateOfBirth) => (dateOfBirth ? Helpers.formatDate(dateOfBirth, "YYYY-MM-DD") : "")

const AccountSettingsContainer = () => {
  const formMethods = useForm()
  const dispatch = useDispatch()
  const {
    handleSubmit,
    reset,
    formState: { isDirty }
  } = formMethods
  const userInfo = useSelector(getUserInfo)
  const [isSubmitted, setIsSubmitted] = useState(false)

  useEffect(() => {
    reset({
      ...userInfo,
      dateOfBirth: formatDateOfBirth(userInfo.dateOfBirth),
      bankAbaRoutingBicOrSwift: "",
      bankIban: "",
      accountNumber: "",
      routingNumber: ""
    })
  }, [userInfo, reset])

  const showSubmittedState = async () => {
    const TimeToShowSubmittedStateInMilliseconds = 5000
    setIsSubmitted(true)
    await sleep(TimeToShowSubmittedStateInMilliseconds)
    setIsSubmitted(false)
  }

  // We don't enforce required fields on submission of this page, even if they have an asterisk. This is because we
  // don't want to force members to include something like IBAN number when all they want to do is change a different
  // field like Personal Email. We do however check for the required (*) bank fields prior to a member submitting a
  // transaction. We plan on eventually improving this UX when it rises in priority.
  const onSubmit = handleSubmit(async (payload) => {
    await dispatch(updateUserInfo(payload))
    showSubmittedState()
  })

  const context = {
    onSubmit,
    isSubmitted
  }

  return (
    <AccountSettingsContext.Provider value={context}>
      <FormProvider {...formMethods}>
        <Form onSubmit={isDirty ? onSubmit : null} className="w-100">
          <AccountSettings />
        </Form>
      </FormProvider>
    </AccountSettingsContext.Provider>
  )
}

export default AccountSettingsContainer
